import { useState } from "react";
import {
  Menu,
  Button,
  Group,
  ActionIcon,
  Text,
  UnstyledButton,
  Indicator,
} from "@mantine/core";
import {
  IconBell,
  IconBrandYoutube,
  IconHelpCircle,
  IconMessageCircle,
  IconUsersGroup,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [opened, setOpened] = useState(false);
  const [channelMenuOpened, setChannelMenuOpened] = useState(false);
  const [notifOpened, setNotifOpened] = useState(false);

  const channels = [
    { id: 1, name: "Marketing" },
    { id: 2, name: "Design" },
    { id: 3, name: "Development" },
  ];
  return (
    <div
    // style={{
    //   padding: "1px",
    //   backgroundColor: "#fff",
    //   position: "fixed",
    //   bottom: 0,
    //   zIndex: 1,
    //   boxShadow: "2px 2px",
    //   borderTop: "1px solid #e5e5e5",
    //   width: "100%",
    // }}
    >
      {/* Left Side Icons */}
      {/* <Group position="apart" ml={"lg"}>
        <Group>
          <Menu
            opened={channelMenuOpened}
            onChange={setChannelMenuOpened}
            withinPortal
          >
            <Menu.Target>
              <UnstyledButton>
                <Group spacing={0}>
                  <IconUsersGroup stroke={1} size={12} />
                  <Text color="dimmed" size={8}>
                    Channel
                  </Text>
                </Group>
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              {channels.map((channel) => (
                <Menu.Item key={channel.id}>{channel.name}</Menu.Item>
              ))}
              <Menu.Item>Start New Channel</Menu.Item>
            </Menu.Dropdown>
          </Menu>   
        </Group>
        <Group position="right">
          {/* Notification Icon with Red Dot */}
      {/* <Menu opened={notifOpened} onChange={setNotifOpened} withinPortal>
            <Menu.Target>
              <Indicator color="red" size={8} offset={5} position="top-end">
                <ActionIcon
                  onClick={() => setNotifOpened((o) => !o)}
                  size={"xs"}
                  mr={"sm"}
                >
                  <IconBell />
                </ActionIcon>
              </Indicator>
            </Menu.Target>
            <Menu.Dropdown>
              <Text size="sm" px="md" py="xs" weight={500}>
                Upgrade Your Package
              </Text>
              <Menu.Item
                style={{
                  fontWeight: "bold",
                  color: "#fff",
                  background: "linear-gradient(135deg, #ff416c, #ff4b2b)",
                  position: "relative",
                  overflow: "hidden",
                  marginBottom: "8px",
                }}
                component={Link}
                to={"/subscriptionpage"}
              >
                Upgrade to Basic
                <div className="shine"></div>
              </Menu.Item>
             
            </Menu.Dropdown>

          </Menu> */}

      {/* <Menu opened={opened} onChange={setOpened} withinPortal>
            <Menu.Target>
              <ActionIcon
                onClick={() => setOpened((o) => !o)}
                size={"xs"}
                mr={"sm"}
              >
                <IconHelpCircle />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Help Center</Menu.Item>
              <Menu.Item>Contact Support</Menu.Item>
              <Menu.Item>FAQs</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Group> */}
    </div>
  );
}
